import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

export default function Layout() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="nav-brand">
          <Link to="/">Home</Link>
        </div>
        <div className="nav-links">
          <Link to="/">Dashboard</Link>
          <Link to="/inventory">Inventar</Link>
          <Link to="/expiry-calendar">Verfallskalendar</Link>
          <Link to="/orders">Bestellungen</Link>
          {isAdmin && (
            <>
              <Link to="/admin" className="admin-link">Benutzerverwaltung</Link>
              <Link to="/admin/available-items" className="admin-link">Artikel Übersicht</Link>
            </>
          )}
        </div>
        <div className="nav-user">
          <span>{user?.username} {isAdmin && <span className="admin-badge">Admin</span>}</span>
          <button onClick={handleLogout} className="btn-logout">Abmelden</button>
        </div>
      </nav>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
